/**
 * Created by YJZX-LCH on 2017-05-23.
 */
import axios from './axios.js';
import qs from 'qs';

export default {
  //查询学校信息
  getAllSchools() {
    return axios.get('/api/campusList').then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  //根据学校id查询班级信息
  getAllClass(id){
    return axios.get(`/api/list?campusId=${id}`).then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  //签到缺勤下拉框数据查询
  getAllQueryTheSignInStatus(schoolId, gradeId) {
    return axios.get('/api/queryTheSignInStatus').then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  //查询签到学生
  getAllSignInStudents(list) {
    return axios.get(`/api/signInList?campusId=${list.campusId}&classId=${list.classId}&lessons=${list.lessons}`).then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  //提交签到学生信息
  createSignIn(list) {
    return axios.post('/api/signIn',{studentList:list},{
      headers: {
          'Content-Type': 'application/json'
      }
    }).then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  //学员花名册查询
  getStudents(schoolId, gradeId, page) {
    return axios.get('/api/rosterList', {
      params: {campusId: schoolId, classId: gradeId,pageNumber:page}
    }).then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  //查询学员个人信息
  getStudentProfileInfo(params) {
    return axios.get('/api/studentInformation', {
      params: params
    }).then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getAttendanceList(params) {
    return axios.get('/wedu/v1/course/sign-in-record', {
      params: params
    }).then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  },
  getTeacherProfileInfo() {
    return axios.get('/wedu/v1/config/working-state').then(response => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回错误');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/teacher.js